module.exports = __webpack_public_path__ + "slide5-release.29cb97ec8551ff8f7879c0ffce7dafd3.hashedasset.svg";